import gql from 'graphql-tag'

const forgotPassword = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email)
  }
`

export { forgotPassword }
